var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.click}},[_c('div',{staticClass:"button1 dflex-c"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }